/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */
import type {
  GroupAdmission,
  GroupAdmissionCreate,
  GroupAdmissionCreateRequest,
  GroupAdmissionRequest,
  GroupsAdmissionsListParams,
  PaginatedGroupAdmissionList,
  PatchedGroupAdmissionRequest
} from '../types';

import { apiV2 } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Get a list of group admissions with optional filtering
 * @summary List group admissions
 */
export const groupsAdmissionsList = (
    groupId: string,
    params?: GroupsAdmissionsListParams,
 options?: SecondParameter<typeof apiV2<PaginatedGroupAdmissionList>>,) => {
      return apiV2<PaginatedGroupAdmissionList>(
      {url: `/groups/${groupId}/admissions/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Create a single group admission or multiple group admissions in bulk. Returns a single object or array depending on input.
 * @summary Create group admission(s)
 */
export const groupsAdmissionsCreate = (
    groupId: string,
    groupAdmissionCreateRequest?: GroupAdmissionCreateRequest,
 options?: SecondParameter<typeof apiV2<GroupAdmissionCreate>>,) => {
      return apiV2<GroupAdmissionCreate>(
      {url: `/groups/${groupId}/admissions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: groupAdmissionCreateRequest
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const groupsAdmissionsRetrieve = (
    groupId: string,
    id: string,
 options?: SecondParameter<typeof apiV2<GroupAdmission>>,) => {
      return apiV2<GroupAdmission>(
      {url: `/groups/${groupId}/admissions/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const groupsAdmissionsUpdate = (
    groupId: string,
    id: string,
    groupAdmissionRequest: GroupAdmissionRequest,
 options?: SecondParameter<typeof apiV2<GroupAdmission>>,) => {
      return apiV2<GroupAdmission>(
      {url: `/groups/${groupId}/admissions/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: groupAdmissionRequest
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const groupsAdmissionsPartialUpdate = (
    groupId: string,
    id: string,
    patchedGroupAdmissionRequest?: PatchedGroupAdmissionRequest,
 options?: SecondParameter<typeof apiV2<GroupAdmission>>,) => {
      return apiV2<GroupAdmission>(
      {url: `/groups/${groupId}/admissions/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedGroupAdmissionRequest
    },
      options);
    }
  export type GroupsAdmissionsListResult = NonNullable<Awaited<ReturnType<typeof groupsAdmissionsList>>>
export type GroupsAdmissionsCreateResult = NonNullable<Awaited<ReturnType<typeof groupsAdmissionsCreate>>>
export type GroupsAdmissionsRetrieveResult = NonNullable<Awaited<ReturnType<typeof groupsAdmissionsRetrieve>>>
export type GroupsAdmissionsUpdateResult = NonNullable<Awaited<ReturnType<typeof groupsAdmissionsUpdate>>>
export type GroupsAdmissionsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof groupsAdmissionsPartialUpdate>>>
